import { CompositeSpine } from 'game/components/CompositeSpine.js';

export class Xylophone extends CompositeSpine {
  constructor({ scene, position = { x: 0, y: 0 }, scale = 1 }) {
    super({
      scene: scene,
      position: position,
      scale: scale,
      keys: [
        'base',
        'note_1',
        'note_2',
        'note_3',
        'note_4',
        'note_5',
        'note_6',
        'note_7',
        'note_8',
      ],
    });
    this.play('idle', true);
  }

  play(animationId, loop = false, ignoreIfPlaying = false) {
    if (animationId === 'idle') {
      this.playAll(animationId, loop, ignoreIfPlaying);
    } else {
      this.playNotes(animationId);
    }
  }

  createBubble(id) {
    this.bubble && this.bubble.destroy();
    this.bubble = this.scene.add.spine(0, -400, 'bubble', 'idle');
    this.bubble.setSkinByName(`bubble_${id}`);
    this.add(this.bubble);
  }

  playNote(id, animationId) {
    this.moveSpineToTop('note_' + id);
    this.playSpine(`note_${id}`, animationId, false, false);
    this.bubble?.play('interact', false, false);
  }

  playNotes(animationId) {
    const spines = ['1', '2', '3', '4', '5', '6', '7', '8'];
    let time = 0;
    for (const spineId of spines) {
      this.scene.time.addEvent({
        delay: time,
        callback: this.createBubble,
        callbackScope: this,
        args: [spineId],
      });
      this.scene.time.addEvent({
        delay: time + 500,
        callback: this.playNote,
        callbackScope: this,
        args: [spineId, animationId],
      });
      time += 1000;
    }
  }

  removeAllListeners() {}

  destroy() {
    this.scene?.time?.removeAllEvents();
    super.destroy();
    // this.scene = null;
    // if (this.bubble) {
    //   this.bubble.destroy();
    //   this.bubble = null;
    // }
  }
}
